"use strict";
import { draw_emails, draw_one_email  } from './emails.js';
import {convertMysqlDateTimeToJSDate, formatDateTime} from './utils/date_utils.js';

export function drawInitialActivities(data){

	console.error(data)
	//createActivityAction(data)
	//createActivityEmail()
	//createActivityAgentMessage()
//	let actvs = data.activities;
	data.forEach(activity => {
		//1 - bot; 2 - request email 3 reply from agent 4 submission state change 5 - submission activity
		let html = '';
		if(activity.type_id == '2'){
			//2 - request email to Agent
			//html = createRequestAgentEmail(activity);

			let email_obj = {
				'id' : activity.email_id,
				'formatted_date' : activity.formatted_date,
				'email_from' : activity.email_from,
				'name_from' : activity.user_name,
				'email_content' : activity.email_content,
				'email_subject' : activity.email_subject,
			}
			html = draw_one_email(email_obj, 2);
		} else if(activity.type_id == '1' || activity.type_id == '6'){
			//1 - bot
			html = simpleActivity(activity);
		} else if(activity.type_id == '3'){
			//3 reply from agent

			let email_obj = {
				'id' : activity.email_id,
				'formatted_date' : activity.formatted_date,
				'email_from' : activity.email_from,
				'name_from' : activity.user_name,
				'email_content' : activity.email_content,
				'email_subject' : activity.email_subject,
			}
			html = draw_one_email(email_obj, 3);
		} else {
			html = simpleActivity(activity);
		}

		$('.full-story-history').append(html);
	});
}

export function simpleActivity(activity) {
	let user_type_class = '';
//	1 - bot; 2 - request email 3 reply from agent 4 submission state change 5 - submission activity
	//6 - message to bot
	let date_pure = activity.added;
	let formattedMessage = '';
	if(activity.activity_message){
		formattedMessage = activity.activity_message.replace(/\n/g, '<br>');
	}

	let user_info = activity.user_name;
	if (user_info == null || String(user_info.trim()) === '') {
		console.error('activity has no user_info to display')
		user_info = '[unavailable user_info]'
	}
	let html = `
		<div class="historical-change-v2 activity_type_id_${activity.type_id ?? 0}">
			<div class="user_info_container">
				<div class="user_info_wrap">
					<div class="user_info">${user_info}</div>
					<div class="date_activity">${formatDateTime(convertMysqlDateTimeToJSDate(date_pure))}</div>
				</div>
				<div class="value">${formattedMessage}</div>
			</div>
		</div>
	`;
	return html;
}





function escapeHtml(str) {
	if (!str) {
		return ''; // Return an empty string if str is null or undefined
	}
	return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

//EMAIL from AGENT
function createActivityAgentMessage(activity) 	{
	let date_pure = '2024-08-28 02:46:26';
	let date = new Date(date_pure + 'Z');

	let user_info_text = 'Agent Name';
	let content_text = 'Hi Paul here is additional information as requestion.';

	let own_class = false ? 'own' : '';
	let files_html = [
		'<li class="file"><a href="#" download="file name .pdf" >file name .pdf</a></li>',
		'<li class="file"><a href="#" download="loss run .pdf">loss run .pdf</a></li>',
	];
	let email_from = activity.email_from
	if (email_from == null || String(email_from.trim()) === '') {
		console.error('activity has no email_from to display')
		email_from = '[unavailable email_from]'
	}
	let html = `<div class="historical-change-v2 agent activity_type_id_${activity.type_id}">
						<div class="value historical-email sd43">
							<div class="header">
								<span class="header_title">FROM:</span>
								<span class="to">${email_from}</span>
								<hr>
									<span class="header_title">Subject:</span>
									<span class="subject">${activity.email_subject}</span>
									<hr>
							</div>
							<pre class="value">${activity.email_content}</pre>
						</div>`;
	$('.full-story-history').append(html);
}

//EMAIL TO AGENT
function createRequestAgentEmail(activity) {


	let to_text = 'agentname@gmail.com';
	let subject_text = 'RE BSRI Submission #2344';
	let content_text = 'Hi Agent name,\n' +
		'We still need 2 more loss runs for this deal. \n' +
		'Please email us at your earliest conviniest in reply to this email.';
	let bottom_right_text = 'DOT: 123245';
	let bottom_left_text = 'Submission #2338';

	let own_class = true ? 'own' : '';

	let email_to = activity.email_to;
	if (email_to == null || String(email_to.trim()) === '') {
		console.error('activity has no email_to to display')
		email_to = '[unavailable email_to]'
	}

	let html = `<div class="historical-change-v2 email ${own_class}">
							<div class="user_info_wrap">
								<div class="user_info">${activity.user_name}</div>
								<div class="date_activity">${formatDateTime(convertMysqlDateTimeToJSDate(activity.added))}</div>
							</div>
							<div class="value historical-email casr234">
								<div class="header">
									<span class="header_title">TO:</span>
									<span class="to">${email_to}</span>
									<hr />
									<span class="header_title">Subject:</span>
									<span class="subject">${activity.email_subject}</span>
									<hr />
								</div>
								<pre class="value">${activity.email_content}</pre>
							</div>
						</div>`;
	$('.full-story-history').append(html);
}



export function drawNoActivities(activities){
	activities.forEach(activity => {
		let html = `
							<div class="historical-change-v2">
								<div class="value">No Activities</div>
							</div>
						`;
		$('.full-story-history').append(html);
	});
}
